import { render, staticRenderFns } from "./LargestClientsPanel.vue?vue&type=template&id=15c1277b&scoped=true&lang=pug"
import script from "./LargestClientsPanel.vue?vue&type=script&lang=js"
export * from "./LargestClientsPanel.vue?vue&type=script&lang=js"
import style0 from "./LargestClientsPanel.vue?vue&type=style&index=0&id=15c1277b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c1277b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
